import {Breadcrumbs} from '../breadcrumbs/breadcrumbs.comp';
import {Resolution} from './resolution/resolution.comp';
import {Feedback} from './feedback/feedback.comp';
import {ArticleList} from '../article-list/article-list.comp';
import {BaseWidgetProps} from './../../widget-container';
import {ArticleView} from './article-view/article-view.comp';
import { Article } from '@wix/answers-api';
import * as React from 'react';
// import {translate} from '../../../common/translate';
import {EventType} from '../../../common/logger/event-type';

export type ArticlePageProps = {
	article: Article | null;
	baseConfig: BaseWidgetProps;
};

export class ArticlePage extends React.Component<ArticlePageProps, any> {
	state = {
		relatedArticles: []
	};

	constructor (props: any) {
		super(props);
	}

	componentDidMount () {
		if (this.props.article) {
			this.props.baseConfig.logger.logEvent(EventType.ARTICLE_VIEW, {
				articleId: this.props.article.id,
				articleTitle: this.props.article.title
			});
		}
	}

	componentWillMount () {
		if (this.props.article) {
			this.props.baseConfig.kbApi.getRelatedArticlesNewApi(this.props.article.id)
			.then((articles: any) => {
				this.setState({ relatedArticles: articles });
			});
		}
	}

	render () {
		const article = this.props.article;
		const translate = this.props.baseConfig.translate;
		if (article) {
			const ratingComp = (
				<div className='feedback-container'>
					<hr/>
					<Feedback article={article} baseConfig={this.props.baseConfig}/>
				</div>
			);

			const relatedArticlesComp = this.state.relatedArticles.length ?
					(
						<div className='related-articles'>
							<hr/>
							<h3>{translate('widget-ng.article-page.related-title')}</h3>
							<ArticleList
								articles={this.state.relatedArticles}
								goToState={this.props.baseConfig.widgetNavigator.goToState}
								withIcons={true}
							/>
						</div>
					) : null;

			const breadcrumbs = article.categoryId ?
				(<Breadcrumbs categoryId={article.categoryId} baseConfig={this.props.baseConfig} linkToCurrentCategory={true}/>) :
				null;

			return (
				<div className='article-page kb-page'>
					{breadcrumbs}
					<div className='inner-article-content'>
						<Resolution article={article} baseConfig={this.props.baseConfig} />
						<ArticleView article={article} baseConfig={this.props.baseConfig} />
						{ratingComp}
						{relatedArticlesComp}
					</div>
				</div>
			);
		} else {
			return (null);
		}
	}
}
